<template>
    <main class="mt-3 main-carousel pl-6 pr-6">
     <Carousel
         :perPageCustom='[[576,3],[768,6],[1200,8]]'
         v-if="loading"
         :paginationEnabled='false'
         :autoplay='autoplay'
         :autoplayTimeout="9999999"
        >
         <Slide v-for="(imgage, index) in 8" :key="index"  class="text-center">
         <v-skeleton-loader
             
              class="mx-auto white"
              max-width="108"
              max-height="108"
              type="image"
            ></v-skeleton-loader>
         </Slide>
        </Carousel>
        <Carousel
        style="min-height:108px"
        v-else
         :autoplay='autoplay'
         :autoplayHoverPause='true'
         :paginationEnabled='false'
         :scrollPerPage='false'
         :loop='true'
         :perPageCustom='[[576,3],[768,6],[1200,8]]'
         :autoplayDirection='$vuetify.rtl? "backward":"forward"'
         navigationNextLabel='<i class="fa fa-arrow-circle-right fa-2x"></i>'
         navigationPrevLabel='<i class="fa fa-arrow-circle-left fa-2x"></i>'
        >
         <Slide v-for="(imgage, index) in CarouselImgages" :key="index"  class="text-center">
          <v-img  class="slider-img" :src="imgage.img" :alt="imgage.title" 
          max-width="108"
          height="108"
          :contain="true"
          >
          <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          <p style="visibility: hidden;" 
          class="text-center mb-0 text-capitalize font-weight-medium rounded-pill pa-1  white--text yellow darken-2" 
          v-text="imgage[lang].title"></p>
         </Slide>
        </Carousel>
    </main>
</template>

<script>
import {Carousel,Slide} from 'vue-carousel';
import firebase from '@/firebase/index';
import {lang} from '@/mixins/index'

export default {
    name:'carousel',
    data() {
        return {
            autoplay:true,
            CarouselImgages:[],
            loading:false,
            /*CarouselImgages:[
                {
                    alt:'pizza',
                    src:'pizza/pizza.png'
                },
                {
                    alt:'pizza',
                    src:'pizza/pizza_one.png'
                },
                {
                    alt:'pizza',
                    src:'pizza/pizza_three.png'
                },
                {
                    alt:'Chicken Burger',
                    src:'burgures/Chicken Burger.png'
                },
                {
                    alt:'Fish Burger',
                    src:'burgures/Fish Burger.png'
                },
                {
                    alt:'KFC Double',
                    src:'burgures/KFC Double .png'
                },
                {
                    alt:'Big Burger',
                    src:'burgures/Big Burger .png'
                },
                {
                    alt:'Burger Fries',
                    src:'burgures/Burger Fries.png'
                },
                {
                    alt:'full mete',
                    src:'burgures/5882486ce81acb96424ffaae.png'
                },
                {
                    alt:'Signature Box',
                    src:'chickens/Kfc Signature Box.png'
                },
                {
                    alt:'Twister Box',
                    src:'chickens/Kfc Twister Box.png'
                },
                {
                    alt:'Chicken Nuggets',
                    src:'chickens/Kfc Chicken Nuggets.png'
                },
                {
                    alt:'Lamb Kebab',
                    src:'salad/Lamb Kebab With Salad.png'
                },
                {
                    alt:'Fattoush Salad',
                    src:'salad/Fattoush Salad.png'
                },
                {
                    alt:'Fattoush Salad with Cucumber',
                    src:'salad/Fattoush Salad with Cucumber and Tomato.png'
                },
                {
                    alt:'Ice Cream Berries',
                    src:'desserts/Ice Cream Berries.png'
                },
                {
                    alt:'Strawberry Horn ',
                    src:'desserts/Strawberry Horn Ice Cream.png'
                },
                {
                    alt:'Strawberry Parfait ',
                    src:'desserts/Strawberry Parfait Ice Cream.png'
                },
                {
                    alt:'Can Pepsi',
                    src:'drinks/Can Pepsi .png'
                },
                {
                    alt:'Can Coca Cola',
                    src:'drinks/Regular Coke Can Coca Cola.png'
                },
                {
                    alt:'Fanta Orange Can',
                    src:'drinks/Fanta Orange Can.png'
                },
                {
                    alt:'Coca Cola Papercup',
                    src:'drinks/Coca Cola Papercup.png'
                },
                {
                    alt:'Light Bottle Coca',
                    src:'drinks/Coke Light Bottle Coca Cola.png'
                },
                {
                    alt:'Plastic Bottle Pepsi',
                    src:'drinks/Plastic Bottle Pepsi .png'
                },
                {
                    alt:'Fanta Orange Bottle',
                    src:'drinks/Fanta Orange Bottle .png'
                }
 
            ]*/
        }
    },
    mixins:[lang],
    components:{
        Carousel,
        Slide
    },
    beforeMount(){
        this.loading=true;
        const storage = firebase.storage();
          firebase.firestore().collection('menu').orderBy('type').get()
          .then((snapshot)=>{
            snapshot.forEach(doc=>{
            storage.ref(doc.data().img).getDownloadURL()
                .then((url) => {
                    this.CarouselImgages.push({
                        ar:{title:doc.data().ar.title},
                        fr:{title:doc.data().fr.title},
                        en:{title:doc.data().en.title},
                        img:url
                    });
                })
                this.loading=false
            })
       })
    }
}
</script>

<style lang="scss">
  .main-carousel{
      direction: ltr !important;
  }
  .main-carousel .VueCarousel-dot-container{
      margin-top: 0 !important;
  }
  .main-carousel .slider-img{
      cursor: pointer;
  }
  .main-carousel .slider-img ~ p{
      font-size: 10pt;
  }
  .main-carousel .slider-img:hover ~ p{
    visibility: visible !important;
    transition: all .5s ease-in-out;
  }
</style>